import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const StudentContext = createContext(null);

export const StudentProvider = ({ children }) => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try { const r = await api.get("/student/auth/me"); setStudent(r.data); }
    catch { setStudent(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    if (window.location.pathname === "/student" || window.location.pathname.startsWith("/student/quiz")) refresh();
    else setLoading(false);
  }, [refresh]);

  const logout = async () => { try { await api.post("/student/auth/logout"); } catch { /* ignore */ } setStudent(null); };

  return <StudentContext.Provider value={{ student, setStudent, loading, refresh, logout }}>{children}</StudentContext.Provider>;
};

export const useStudent = () => useContext(StudentContext);
